import { Grid } from '@achieve/ascend'
import { CardIconList } from 'components/Cards/CardIconList'

import { CardProduct } from 'components/Cards/CardProduct'
import { CardProductListItem } from 'components/Cards/CardProductListItem'

function ThreeProductCard({ content = {}, productCardVariant }) {
  const components = {
    ProductCardsListItem: CardProductListItem,
    CardIconList: CardIconList,
    ProductCard: CardProduct,
  }
  const ProductCardWrapper = components[productCardVariant ?? 'ProductCard']
  return (
    <>
      {content && (
        <Grid
          container
          justifyContent={{ md: 'center' }}
          alignItems={{ xs: 'stretch' }}
          spacing={{ xs: 2, md: 2 }}
          data-testid="home-product-card-section-card-grid"
          margin={0}
        >
          {(content.gridItems || []).map((gridContent, index) => {
            return (
              <Grid
                size={{ xs: 12, md: productCardVariant === 'CardIconList' ? 4 : 8, lg: 4 }}
                key={`${gridContent?.sys?.id}-${index}`}
                data-testid={`home-product-card-section-card-grid-item-${index}`}
                className={`${content?.className ? content?.className : ''}`}
              >
                <ProductCardWrapper
                  content={gridContent}
                  index={index}
                  data-testid={`home-product-card-section-card-${index}`}
                />
              </Grid>
            )
          })}
        </Grid>
      )}
    </>
  )
}

export { ThreeProductCard }
